import React from 'react';
import PropTypes from 'prop-types';
import QuoteCarouselCard from './QuoteCarouselCard';
import { Carousel, slickBreakpoints } from './Carousel';
import classNames from 'classnames';

const QuoteCarousel = ({ carouselTitle, quotes, carouselStyleClasses }) => {
  const quoteSliderSettings = {
    centerMode: true,
    centerPadding: '24px',
    responsive: [
      {
        breakpoint: slickBreakpoints.mobile,
        settings: {
          arrows: false,
          centerPadding: '0px',
        },
      },
    ],
    className: 'quote-carousel',
  };

  carouselStyleClasses = classNames(
    'scalable-content-section quote-carousel-section',
    carouselStyleClasses
  );
  return (
    <div className="content-wrapper">
      <div className={carouselStyleClasses}>
        <p className="quote-carousel__title">{carouselTitle}</p>
        <Carousel options={quoteSliderSettings}>
          {quotes.map((quote, i) => {
            return <QuoteCarouselCard key={i} {...quote} />;
          })}
        </Carousel>
      </div>
    </div>
  );
};

QuoteCarousel.propTypes = {
  quotes: PropTypes.arrayOf(PropTypes.object),
  carouselTitle: PropTypes.string,
  carouselStyleClasses: PropTypes.arrayOf(PropTypes.string),
};

export default QuoteCarousel;
